import {memo, useCallback, useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {CheckTree} from 'rsuite'
import * as mediaManager from 'src/app/modules/common/components/fileManager'
import {buildFolderTree, getFolderChildren} from './buildFolderTree'

type Props = {
  value: Array<string>
  onChange: (value: Array<string>) => void
}

const FolderAccessTree = memo(({value, onChange}: Props) => {
  const dispatch = useDispatch()
  const mediaHierarchyData = useSelector((state: any) => state.mediaManager?.mediaHierarchyData)

  useEffect(() => {
    dispatch(mediaManager.actions.getMediaHierarchy())
  }, [])

  const treeData = useMemo(
    () => (mediaHierarchyData?.basename ? buildFolderTree(mediaHierarchyData) : []),
    [mediaHierarchyData]
  )

  const getChildren = useCallback(
    (node: any) => (mediaHierarchyData?.basename ? getFolderChildren(mediaHierarchyData, node.value) : []),
    [mediaHierarchyData]
  )

  return (
    <CheckTree
      data={treeData}
      value={value}
      onChange={(newValue: any) => onChange(newValue)}
      getChildren={getChildren}
      cascade={false}
      style={{height: 'auto'}}
      data-cy='folder-access-tree'
    />
  )
})

export default FolderAccessTree
